export const usd = (n: number, compact = true): string =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: compact && Math.abs(n) >= 10000 ? "compact" : "standard",
    maximumFractionDigits: compact && Math.abs(n) >= 10000 ? 1 : 0,
  }).format(n);

export const num = (n: number): string => new Intl.NumberFormat("en-US").format(n);

export const pct = (n: number, digits = 0): string => `${n.toFixed(digits)}%`;

export function relDate(iso: string, today = new Date("2026-08-16T12:00:00Z")): string {
  const d = new Date(iso);
  const days = Math.round((d.getTime() - today.getTime()) / 86400000);
  if (days === 0) return "today";
  if (days === 1) return "tomorrow";
  if (days === -1) return "yesterday";
  if (days < 0) return `${Math.abs(days)}d ago`;
  if (days < 45) return `in ${days}d`;
  const months = Math.round(days / 30);
  return `in ${months}mo`;
}

export function shortDate(iso: string): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function timeAgo(iso: string, now = new Date("2026-08-16T12:00:00Z")): string {
  const secs = Math.round((now.getTime() - new Date(iso).getTime()) / 1000);
  if (secs < 3600) return `${Math.max(1, Math.round(secs / 60))}m`;
  if (secs < 86400) return `${Math.round(secs / 3600)}h`;
  return `${Math.round(secs / 86400)}d`;
}

export const initials = (name: string): string =>
  name.split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

/** Deterministic warm color for a monogram, seeded by string. */
export function seedColor(s: string): string {
  const palette = ["#4A72A8", "#3F8F63", "#C9821A", "#8A5A9E", "#BB472C", "#4E8C8A"];
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return palette[h % palette.length];
}
